import http from './request'

export function listVipPlans() {
  return http.get('/vip/plans')
}

export function getVipStatus() {
  return http.get('/vip/status')
}

export function createVipOrder(planType, channel = 'native') {
  return http.post('/vip/orders', { plan_type: planType, channel })
}

export function syncVipOrder(orderId) {
  return http.post('/vip/orders/' + orderId + '/sync', {})
}

export function confirmVipDevPay(orderId) {
  return http.post('/vip/orders/' + orderId + '/pay-dev', {})
}
